module.exports = __webpack_public_path__ + "img/ES1568.037e18ff.png";